import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { UserAssignTagsModule } from "@vp/administration/ui/user-assign-tags";
import { GenericDialogModule } from "@vp/shared/components/generic-dialog";
import { MaterialModule } from "@vp/shared/material";
import { ContextDisplayModule } from "@vp/shared/pipes/context-display";
import { UtilitiesModule } from "@vp/shared/utilities";
import { NgxPermissionsModule } from "ngx-permissions";

import { UserAssignedTagsComponent } from "./user-assigned-tags.component";

@NgModule({
  imports: [
    CommonModule,
    ContextDisplayModule,
    GenericDialogModule,
    MaterialModule,
    MatExpansionModule,
    MatSlideToggleModule,
    NgxPermissionsModule,
    UserAssignTagsModule,
    UtilitiesModule
  ],
  declarations: [UserAssignedTagsComponent],
  exports: [UserAssignedTagsComponent]
})
export class UserAssignedTagsModule {}
